import { render, staticRenderFns } from "./Cirugia.vue?vue&type=template&id=34bb6370&"
import script from "./Cirugia.vue?vue&type=script&lang=js&"
export * from "./Cirugia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports